import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SearchBox from '../../../rsmCoreComponents/components/Search/SearchBox'
import { Styles } from '../../../types'

const styles: Styles = {
  searchContainer: (theme) => ({
    [theme.breakpoints.up('tablet')]: {
      width: '20rem',
    },
  }),
}

interface InsightsSearchProps {
  setFilter: React.Dispatch<React.SetStateAction<string>>
}

const InsightsSearch = ({ setFilter }: InsightsSearchProps) => {
  const { t } = useTranslation()

  return (
    <Box
      id="insights-filter-chips-clear-all-focus-target"
      sx={styles.searchContainer}>
      <SearchBox
        setFilter={setFilter}
        placeholderText={t('SearchByKeyword')}
        testId="Txt_Insight_Search"
      />
    </Box>
  )
}

export default InsightsSearch
